import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatentInfo, PatentsModel } from '../../types';
import { AbstractModel } from '@patsnap/tahiti-core';

@injectable()
export class PatentsModelImpl extends AbstractModel<PatentInfo[]> implements PatentsModel {
    protected _modelData: PatentInfo[] = [];
}
